document.addEventListener('DOMContentLoaded', () => {

  // Create toast
  const toast = document.createElement('div');
  toast.id = 'variant-stock-toast';
  toast.innerHTML = 'This variant is out of stock. Switching to an available option...';

  toast.style.cssText = `
    position: fixed;
    bottom: 30px;
    right: 30px;
    background: #d32f2f;
    color: #fff;
    padding: 14px 20px;
    border-radius: 8px;
    z-index: 99999;
    display: none;
    font-size: 14px;
  `;

  document.body.appendChild(toast);

  document.addEventListener('click', function(e) {

    const input = e.target.closest('input[type="radio"]');

    if (!input) return;

    const available = input.dataset.optionAvailable;

    if (available === 'false') {

      e.preventDefault();

      toast.style.display = 'block';

      setTimeout(() => {

        toast.style.display = 'none';

        const availableVariant = document.querySelector(
          'input[data-option-available="true"]'
        );

        if (availableVariant) {
          availableVariant.click();
        }

      }, 3000);
    }

  });

});